













































import { Usuario, UsuarioNovo } from "@/services/usuarios.service";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Component } from "vue-property-decorator";
import ComboRoles from "./ComboRoles.vue";

@Component({
  components: {
    ComboRoles,
  },
})

export default class Formulario extends mixins(GlobalMixin){

  @Prop() readonly value!: string;
  @Prop() readonly usuario!: Usuario | UsuarioNovo;
  @Prop() readonly rules!: object;
  
}
